import api from './api'

const findBySlug = (slug) => {
  return api.get(`photo/find-by-slug/${slug}`)
}

export { findBySlug }
